import { inject } from '@angular/core';
import { CanMatchFn, Router } from '@angular/router';
import { AuthService } from '../../auth.service';

/** canMatch (not canActivate) so an unauthorised visitor never downloads the lazy
 *  feature chunk; the UrlTree sends them back to Home. */
export const catalogAdminGuard: CanMatchFn = () =>
  inject(AuthService).isCatalogAdmin()
    ? true
    : inject(Router).createUrlTree(['']);
